// =============================================================================
// Store: tema UI (hallazgo A2 resuelto)
// -----------------------------------------------------------------------------
// Estado global de apariencia (dark mode). La persistencia y la aplicación de
// la clase `.dark` la maneja el composable useDarkMode.
// =============================================================================
import { ref } from 'vue';

const isDark = ref(false);

export function useUiStore() {
  const setDarkMode = (value) => {
    isDark.value = !!value;
  };
  const toggleDarkMode = () => {
    isDark.value = !isDark.value;
  };

  return { isDark, setDarkMode, toggleDarkMode };
}